import { ComponentPropsWithoutRef } from 'react';
/* eslint-disable react/button-has-type */
const Button = ({ className, ...rest }: ComponentPropsWithoutRef<'button'>) => (
  <button
    {...rest}
    className={`
      border
      p-1.5
      flex
      align-center
      !rounded-lg
      font-bold
      ${className}
    `}
  />
);

export default Button;
